













import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters(['isAdmin', 'isUser', 'isDeveloper'])
  }
})
export default class MarketplaceHeader extends Vue {
}
